import React from "react";
import "./App.scss";
import Widget from "./containers/Widget/Widget";
import { makeStyles } from "@material-ui/core/styles";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { SnackbarProvider } from "notistack";

import Notification from "./hoc/Notification/Notification";

const useStyles = makeStyles((theme) => ({
  variantSuccess: {
    backgroundColor: "#00A3AD !important",
  },
  variantError: {
    backgroundColor: "#F64E60 !important",
  },
}));

const App = () => {
  const classes = useStyles();

  return (
    <SnackbarProvider
      classes={classes}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      maxSnack={2}
    >
      <div className="App">
        <BrowserRouter>
          <Notification />
          <Switch>
            <Route path="/" exact component={Widget} />
            <Redirect to="/" />
          </Switch>
        </BrowserRouter>
      </div>
    </SnackbarProvider>
  );
};

export default App;
